/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"
import { isNotEmpty, getPriceStr } from "./utils/site_utlis"
import { propertyIntro } from "./utils/property_utils";
import { site_name } from "./constant"
import { startCase, capitalize } from "lodash";

const SeoResult = ({ lang, meta, searchParams }) => {
  const data = useStaticQuery(
    graphql`
            query {
                site {
                    siteMetadata {
                        title
                        siteUrl
                        description
                        author
                    }
                }

                glstrapi {
                  propertySearch {
                      property_type {
                        id
                        label
                        value
                        department
                      }
                  }
                }
            }
        `
  )


  const { pathname } = useLocation();
  var metaDescription = data?.site?.siteMetadata.description;
  var property_type_list = data?.glstrapi?.propertySearch?.property_type;

  const title = propertyIntro({ ...searchParams, introCopy: false, isMetaTitle: true }, property_type_list)
  const metaIntro = propertyIntro({ ...searchParams, introCopy: true }, property_type_list);

  //console.log("searchParams seo", searchParams)

  metaDescription = searchParams?.type === "newhomes" ? metaDescriptionNewHomes(searchParams, metaIntro, property_type_list) : metaDescriptionContent(searchParams, metaIntro, property_type_list);


  var currentUrl = '';
  currentUrl = process.env.GATSBY_SITE_URL + pathname;

  // set no index for result pagination
  let hasPagination = false;
  if (pathname !== undefined && pathname) {
    let pageStr = pathname.split('page-');
    hasPagination = pageStr[1] || false;
    if (pageStr[0] !== undefined) {
     currentUrl = process.env.GATSBY_SITE_URL + pageStr[0];
    }
  }


  if (!currentUrl.endsWith('/'))
    currentUrl = currentUrl + '/';

  //remove multiple slashes
  currentUrl = currentUrl.replace(/([^:]\/)\/+/g, "$1");
  //set lowercase url
  currentUrl = currentUrl.toLowerCase();

  let google_site_meta = process.env.GATSBY_GOOGLE_SITE_VERIFICATION ? { name: `google-site-verification`, content: process.env.GATSBY_GOOGLE_SITE_VERIFICATION } : ""

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${data.site.siteMetadata.title}`}
      link={[
        {
          href: currentUrl,
          rel: "canonical"
        }
      ]}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: `${title} | ${data.site.siteMetadata.title}`,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:creator`,
          content: data.site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: `${title} | ${data.site.siteMetadata.title}`,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:site`,
          content: data.site.siteMetadata.author,
        },
        google_site_meta,
      ]
        .concat(
          [
            {
              name: "twitter:card",
              content: "summary",
            },
          ]
        )
        .concat(meta)}
    />
  )
}

SeoResult.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SeoResult.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
}

export default SeoResult;

const metaDescriptionContent = ({ propertyType, areas, minPrice, maxPrice, bedrooms, action, defaultArea, mustInclude, furnishing, department, office_department }, h1_title, property_type_list) => {

  if (areas) {
    areas = areas.replace(/"/g, "");
    if(areas.length < 5){
      areas = areas.toUpperCase();
    } else{
      areas = capitalize(areas);
    }
  } else{
    areas = defaultArea ? defaultArea.replace(" and", ",") : "";
  }   

  //console.log("areas ==>", areas)

  let property_text = "";

  if(office_department === "student"){
    property_text += "student ";
  }

  property_text += department === "commercial" ? "commercial property" : "property"

  if(office_department === "collection"){
    property_text += " collection";
  }

  if(department === "commercial"){
    bedrooms = "";
  }

  var bedroom_text = parseInt(bedrooms) > 0 ? (parseInt(bedrooms) > 1 ? bedrooms+" bedrooms" : bedrooms+" bedroom") : parseInt(bedrooms) === 0 ? "studio" : ""
  var bedroom_text_more = parseInt(bedrooms) > 0 ? (parseInt(bedrooms) > 1 ? "with more than "+bedrooms+" bedrooms" : "with more than "+bedrooms+" bedroom") : parseInt(bedrooms) === 0 ? "with studio" : ""

  //bedroom_text_more = parseInt(bedrooms) === 0 ? "with studios" : "";

  //console.log("bedrooms ==>", bedrooms, bedroom_text_more);

  var filter_prop_type = property_type_list?.length > 0 && property_type_list.filter(item => item.value === propertyType);

  var prop_type = "";

  if(filter_prop_type?.length > 0){
    prop_type = (filter_prop_type[0].label.replace(/\//g,' and ')).toLowerCase()
  } else{
    prop_type = propertyType
  }

  var prop_type_offc = "";
  if(office_department === "student"){
      prop_type_offc += "student ";
  }
  prop_type_offc += prop_type;

  if(office_department === "collection"){
      prop_type_offc += " collection";
  }

  prop_type = prop_type_offc;


  if(mustInclude && mustInclude.length > 0){
    return `Explore the list of ${h1_title} with ${site_name} and request a viewing for the ${property_text} that interests you.`
  }

  if(furnishing){
    return `Explore the list of ${h1_title} with ${site_name} and request a viewing for the ${property_text} that interests you.`
  }

  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(bedrooms) && isNotEmpty(propertyType) && (isNotEmpty(minPrice) || isNotEmpty(maxPrice))) {

    return `Explore ${bedroom_text} ${prop_type} ${action} in ${areas} ${getPriceStr(minPrice, maxPrice)} available with ${site_name}. Contact one of our estate agents for assistance in finding your ${property_text} in ${areas}.`
  }

  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(bedrooms) && isNotEmpty(propertyType)) {
    return `Find the latest collection of ${prop_type} ${action} in ${areas} ${bedroom_text_more}. Contact ${site_name} and letting agents in ${areas}, to arrange a viewing.`
  }
  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(bedrooms) && (isNotEmpty(minPrice) || isNotEmpty(maxPrice))) {
    return `Explore the list of ${property_text} ${action} in ${areas} ${bedroom_text_more} ${getPriceStr(minPrice, maxPrice)} with ${site_name} and request a viewing for the ${property_text} that interests you.`
  }
  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(propertyType) && (isNotEmpty(minPrice) || isNotEmpty(maxPrice))) {
    return `Check out the latest collection of ${prop_type} ${action} in ${areas} ${getPriceStr(minPrice, maxPrice)} with ${site_name} in ${areas}.`
  }
  if (isNotEmpty(action) && isNotEmpty(areas) && (isNotEmpty(minPrice) || isNotEmpty(maxPrice))) {
    return `Locate the right ${property_text} ${action} in ${areas} ${getPriceStr(minPrice, maxPrice)} with ${site_name}. Book an appointment with one of our ${property_text} experts in ${areas}.`
  }
  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(bedrooms)) {
    return `Explore ${property_text}  ${action} in ${areas} ${bedroom_text_more} here. Contact our expert estate agents today to get assistance in finding the right ${property_text} in ${areas}.`
  }
  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(propertyType)) {
    return `Looking for a ${prop_type} ${action} in ${areas}? ${property_text} experts from ${site_name} are here to help.`
  }
  if (isNotEmpty(action) && isNotEmpty(areas)) {
    if (areas === defaultArea.replace(" and", ",")) {
      return `Explore our latest collection of ${property_text} ${action} in ${areas}. Contact ${site_name} in ${areas} to find the right ${property_text} for you.`
    } else {
      return `Explore our range of ${property_text} ${action} in ${areas}. Contact our ${property_text} experts to find the right ${property_text} ${action} in ${areas}.`
    }

  }
  if (isNotEmpty(action)) {
    return `Explore our latest collection of ${property_text} ${action} in ${areas}. Contact ${site_name} in ${areas} to find the right ${property_text} for you.`
  }
}

const metaDescriptionNewHomes = ({ propertyType, areas, minPrice, maxPrice, bedrooms, action, defaultArea, mustInclude, furnishing, department }, h1_title, property_type_list) => {

  if (areas) {
    areas = capitalize(areas);
  } else{
    areas = defaultArea.replace(" and", ",");
  }   

  let property_text = "new homes";

  var bedroom_text = parseInt(bedrooms) > 0 ? (parseInt(bedrooms) > 1 ? bedrooms+" bedrooms" : bedrooms+" bedroom") : parseInt(bedrooms) === 0 ? "studio" : ""
  var bedroom_text_more = parseInt(bedrooms) > 0 ? (parseInt(bedrooms) > 1 ? "with more than "+bedrooms+" bedrooms" : "with more than "+bedrooms+" bedroom") : parseInt(bedrooms) === 0 ? "with studio" : ""

  //bedroom_text_more = parseInt(bedrooms) === 0 ? "with studios" : "";

  //console.log("bedrooms ==>", bedrooms, bedroom_text_more);

  var filter_prop_type = property_type_list?.length > 0 && property_type_list.filter(item => item.value === propertyType);

  var prop_type = "";

  if(filter_prop_type?.length > 0){
    prop_type = (filter_prop_type[0].label.replace(/\//g,' and ')).toLowerCase()
  } else{
    prop_type = propertyType
  }


  if(mustInclude && mustInclude.length > 0){
    return `Explore the list of ${h1_title} with ${site_name} and request a viewing for the ${property_text} that interests you.`
  }

  if(furnishing){
    return `Explore the list of ${h1_title} with ${site_name} and request a viewing for the ${property_text} that interests you.`
  }

  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(bedrooms) && isNotEmpty(propertyType) && (isNotEmpty(minPrice) || isNotEmpty(maxPrice))) {
    return `Find new ${prop_type} ${action} in ${areas} ${bedroom_text} ${getPriceStr(minPrice, maxPrice)} with ${site_name}. Contact one of our ${property_text} professional today to get assistance in finding the best property in ${areas}.`
  }

  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(bedrooms) && isNotEmpty(propertyType)) {
    return `Find the latest new ${prop_type} ${action} in ${areas} ${bedroom_text_more}. Contact ${site_name} estate agents and letting agents in ${areas}, to arrange a viewing.`
  }
  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(bedrooms) && (isNotEmpty(minPrice) || isNotEmpty(maxPrice))) {
    return `Explore the list of ${property_text} ${action} in ${areas} ${bedroom_text_more} ${getPriceStr(minPrice, maxPrice)} with ${site_name} and request a viewing for the ${property_text} that interests you.`
  }
  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(propertyType) && (isNotEmpty(minPrice) || isNotEmpty(maxPrice))) {
    return `Check out the latest collection of new ${prop_type} ${action} in ${areas} ${getPriceStr(minPrice, maxPrice)} with ${site_name} estate agents and letting agents in ${areas}.`
  }
  if (isNotEmpty(action) && isNotEmpty(areas) && (isNotEmpty(minPrice) || isNotEmpty(maxPrice))) {
    return `Locate the right ${property_text} ${action} in ${areas} ${getPriceStr(minPrice, maxPrice)} with ${site_name}. Book an appointment with one of our ${property_text} professional in ${areas}.`
  }
  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(bedrooms)) {
    return `Find ${property_text}  ${action} ${bedroom_text_more} in ${areas} here. Contact ${site_name} ${property_text} professionals in ${areas} today to get assistance.`
  }
  if (isNotEmpty(action) && isNotEmpty(areas) && isNotEmpty(propertyType)) {
    return `Searching for a newly built ${prop_type} ${action} in ${areas}? ${site_name} ${property_text} professionals are here to help. `
  }
  if (isNotEmpty(action) && isNotEmpty(areas)) {
    return `Explore our stunning range of ${property_text} ${action} in ${areas}. Contact our ${property_text} team to find the right property ${action} in ${areas}.`

  }

}